/**
 * Biblioteca de conteúdo para agendas de treino.
 *
 * O que uma agenda fitness precisa dizer é o que ninguém lembra no meio da
 * semana: o que fazer hoje, o que anotar, o que descansar. Nada aqui promete
 * resultado — treino é constância e registro, e quem vende agenda não deve
 * prometer corpo.
 *
 * Todo o texto é original, escrito para este gerador: pode ser impresso e
 * vendido com o miolo.
 */
/**
 * Frases para abrir o dia de treino.
 *
 * A ideia é servir tanto para o dia em que o corpo está pronto quanto para o dia
 * em que ele não está: treinar mal-humorado é pior que descansar.
 */
export const FRASES_FITNESS = [
    'O treino de hoje é o aquecimento do treino de daqui a um mês.',
    'Constância bate intensidade em qualquer comparação honesta.',
    'Nem todo treino é recorde. Todo treino conta.',
    'Se estiver sem vontade, faça a primeira série. Depois decida.',
    'Descanso também é treino: é quando o corpo responde.',
    'Anotar a carga é a diferença entre evoluir e torcer.',
    'A melhor rotina é a que sobrevive à semana cheia.',
    'Corpo cansado pede sono, não vergonha.',
    'Comer bem não é recompensa do treino: é parte dele.',
    'Você não precisa treinar como quem você admira. Precisa treinar como quem você é hoje.',
    'Progredir é somar pouco, muitas vezes, por muito tempo.',
    'Compare com o seu mês passado, nunca com o treino dos outros.',
    'Dia de preguiça: reduza o treino, não o compromisso.',
    'O aquecimento é a parte que ninguém aplaude e todo mundo sente falta quando pula.',
    'Alongar depois é mais fácil que explicar a dor depois.',
    'Água e sono resolvem mais treinos perdidos do que suplemento.',
    'Estagnar é dado, não fracasso: hora de rever descanso e volume.',
    'Treinar é a única hora do dia em que só você responde por você.',
    'Um treino curto bem feito vale mais que um treino longo adiado.',
    'Semana ruim acontece. O que não pode acontecer é a segunda semana.',
    'Técnica primeiro: carga depois. Sempre nessa ordem.',
    'Cinco minutos de decisão valem mais que uma hora de desculpa.',
    'Quem mede volume, carga e sono para de andar em círculo.',
    'Volte sempre ao básico: o movimento simples, bem feito, é o que constrói.',
];
/**
 * Ciclo de treino: o que fazer em cada bloco, da semana ao mês.
 *
 * É um checklist de quem treina com plano, para não virar só coleção de fichas.
 */
export const CICLO_DE_TREINO = [
    'Definir o objetivo do ciclo em uma frase',
    'Escolher a frequência semanal que a rotina aguenta',
    'Montar as fichas de treino e revisar com quem orienta',
    'Anotar aquecimento, séries, repetições e carga',
    'Registrar o sono e a energia de cada dia',
    'Fechar a semana somando volume e treinos feitos',
    'A cada 4 semanas, revisar carga, volume e descanso',
    'A cada 12 semanas, mudar o estímulo (e comemorar o que subiu)',
    'Revisar alimentação e hidratação com quem entende',
    'Parar e reavaliar ao primeiro sinal de dor persistente',
];
/**
 * O que sustenta o treino fora da academia.
 *
 * É onde o resultado mora: sono, comida e hidratação.
 */
export const ROTINA_DE_CUIDADOS = [
    'Dormir de 7 a 9 horas',
    'Beber água ao longo do dia, não tudo de uma vez',
    'Proteína nas refeições principais',
    'Caminhada leve nos dias sem treino',
    'Alongar o que ficou tenso na semana',
    'Um dia inteiro de descanso por semana',
    'Anotar energia e humor antes de dormir',
];
/**
 * Sinais de que o corpo está pedindo pausa.
 *
 * Serve para tirar a culpa de quem descansa: parar por alguns dias faz parte do
 * plano, e dor que persiste é assunto de profissional de saúde.
 */
export const SINAIS_DE_PAUSA = [
    'Dor articular que o aquecimento não resolve',
    'Cansaço que continua depois de dormir bem',
    'Carga caindo por duas semanas seguidas',
    'Sono ruim por vários dias',
    'Vontade nenhuma de treinar por mais de uma semana',
    'Dores que persistem: procure avaliação profissional',
];
//# sourceMappingURL=fitness.js.map